module.exports = __webpack_public_path__ + "static/img/far1.f23d2738.png";